// Images provisoires (photos libres de droits Unsplash) — à remplacer par les vraies photos.
const u = (id, w = 1400) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const media = {
  hero: u("photo-1774682060997-f8959850a7d4", 1200),
  essence: u("photo-1772987714654-2df39af2c658", 1200),
  essenceSecondary: u("photo-1677725281623-8abbab1333e2", 900),
  grandPrix: u("photo-1673710672680-944563ff9cce", 1400),
  finalists: u("photo-1677726050511-48866c4a64d9", 1400),
  winners: u("photo-1714176774596-45946a7325fd", 1400),
  categories: u("photo-1656055450593-5f9fc1e88b65", 1600),
  ecosystem: u("photo-1618835962148-cf177563c6c0", 1200),
};
